import React, {FC, PropsWithChildren, useEffect} from 'react';

import {useTheme} from '@gravity-ui/uikit';
import {Theme} from 'ui/../common/constants';
import {MessageType} from 'ui/constants/MessageType';
import {FooterContextProvider} from 'ui/contexts/Footer';
import useHeightPostMessage from 'ui/hooks/useHeightPostMessage';
import {parsePostMessageData} from 'ui/utils/parsePostMessageData';

const IframeLayout: FC<PropsWithChildren<{}>> = ({children}) => {
    const ref = useHeightPostMessage();
    const [_theme, setTheme] = useTheme();
    useEffect(() => {
        const setValue = ({data}: MessageEvent) => {
            const parsedData = parsePostMessageData(data);
            if (parsedData?.message === MessageType.ChangeTheme) {
                const themeValue = parsedData.value;
                if (Object.values(Theme).includes(themeValue)) setTheme(themeValue);
            }
        };

        window.addEventListener('message', setValue);
        return () => window.removeEventListener('message', setValue);
    }, []);

    return (
        <div ref={ref}>
            <FooterContextProvider>{children}</FooterContextProvider>
        </div>
    );
};

export default IframeLayout;
